import { format } from 'date-fns';
import { EMILIA_LOGO_B64 } from './emilia_logo_b64';

export const generateQuotePDFPrintWindow = (quote) => {
    const isUSD = quote.currency === 'USD';
    const currencySymbol = isUSD ? 'USD $' : '$';
    
    const formattedTotalCost = isUSD 
        ? quote.total_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : Math.round(quote.total_price).toLocaleString('es-CL');

    const createdDateStr = quote.created_at 
        ? format(new Date(quote.created_at), 'dd/MM/yyyy') 
        : format(new Date(), 'dd/MM/yyyy');

    const htmlContent = `
    <!DOCTYPE html>
    <html lang="es">
    <head>
        <meta charset="UTF-8">
        <title>Cotización ${quote.quote_number} - Transportes Emilia</title>
        <style>
            body {
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: #1e293b;
                margin: 0;
                padding: 40px;
                background-color: #fff;
                font-size: 13px;
                line-height: 1.5;
            }
            .header-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 25px;
            }
            .brand-logo {
                max-height: 70px;
                width: auto;
                margin-bottom: 8px;
            }
            .brand-title {
                font-size: 24px;
                font-weight: 800;
                color: #0f172a;
                letter-spacing: -0.5px;
                margin: 0;
            }
            .brand-subtitle {
                font-size: 12px;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 1px;
                margin-top: 2px;
            }
            .quote-badge {
                text-align: right;
                vertical-align: top;
            }
            .quote-number {
                font-size: 22px;
                font-weight: 800;
                color: #2563eb;
                margin: 0;
            }
            .quote-date {
                font-size: 12px;
                color: #64748b;
                margin-top: 4px;
            }
            .info-box {
                background-color: #f8fafc;
                border-radius: 8px;
                border: 1px solid #e2e8f0;
                padding: 16px;
                margin-bottom: 25px;
            }
            .info-table {
                width: 100%;
                border-collapse: collapse;
            }
            .info-label {
                font-size: 10px;
                font-weight: 700;
                text-transform: uppercase;
                color: #64748b;
                letter-spacing: 0.5px;
                margin-bottom: 2px;
            }
            .info-value {
                font-size: 14px;
                font-weight: 700;
                color: #0f172a;
            }
            .table-itinerary {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 25px;
            }
            .table-itinerary th {
                background-color: #0f172a;
                color: #ffffff;
                font-size: 11px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                padding: 10px 12px;
                text-align: left;
            }
            .table-itinerary td {
                padding: 12px;
                border-bottom: 1px solid #e2e8f0;
                font-size: 12px;
            }
            .table-itinerary tr:nth-child(even) {
                background-color: #f8fafc;
            }
            .badge-vehicle {
                background-color: #eff6ff;
                color: #1d4ed8;
                border: 1px solid #bfdbfe;
                font-size: 11px;
                font-weight: 700;
                padding: 3px 8px;
                border-radius: 4px;
                display: inline-block;
            }
            .badge-service {
                background-color: #f1f5f9;
                color: #475569;
                border: 1px solid #cbd5e1;
                font-size: 10px;
                font-weight: 600;
                padding: 2px 6px;
                border-radius: 4px;
                text-transform: uppercase;
            }
            .totals-table {
                width: 320px;
                margin-left: auto;
                border-collapse: collapse;
                margin-bottom: 30px;
            }
            .totals-table td {
                padding: 8px 12px;
            }
            .total-row {
                background-color: #0f172a;
                color: #ffffff;
                font-size: 16px;
                font-weight: 800;
            }
            .total-row td {
                padding: 12px;
                border-radius: 6px;
            }
            .notes-card {
                background-color: #fffbebf5;
                border-left: 4px solid #f59e0b;
                border-radius: 4px;
                padding: 14px;
                margin-bottom: 25px;
            }
            .notes-card-title {
                font-size: 11px;
                font-weight: 800;
                color: #b45309;
                text-transform: uppercase;
                margin-bottom: 4px;
            }
            .notes-card-text {
                font-size: 12px;
                color: #78350f;
            }
            .footer-contact {
                background-color: #f1f5f9;
                border-radius: 8px;
                border: 1px solid #cbd5e1;
                padding: 16px;
                text-align: center;
                margin-top: 30px;
            }
            .footer-title {
                font-size: 12px;
                font-weight: 800;
                color: #0f172a;
                text-transform: uppercase;
                margin-bottom: 6px;
            }
            .footer-details {
                font-size: 12px;
                color: #334155;
            }
            .footer-details span {
                margin: 0 10px;
                font-weight: 700;
            }
            @media print {
                body { padding: 0; }
                .no-print { display: none; }
            }
        </style>
    </head>
    <body>
        <div class="no-print" style="margin-bottom: 20px; text-align: right;">
            <button onclick="window.print()" style="background-color: #2563eb; color: white; border: none; padding: 10px 20px; font-weight: bold; border-radius: 6px; cursor: pointer;">
                🖨️ Imprimir / Guardar en PDF
            </button>
        </div>

        <table class="header-table">
            <tr>
                <td style="vertical-align: middle;">
                    <img src="${EMILIA_LOGO_B64}" alt="Transportes Emilia" class="brand-logo" />
                    <h1 class="brand-title">TRANSPORTES EMILIA</h1>
                    <div class="brand-subtitle">Servicios Especiales & Transporte Ejecutivo</div>
                </td>
                <td class="quote-badge">
                    <h2 class="quote-number">COTIZACIÓN #${quote.quote_number}</h2>
                    <div class="quote-date">Fecha de emisión: <strong>${createdDateStr}</strong></div>
                    <div class="quote-date" style="font-weight: bold; color: #16a34a; margin-top: 4px;">Oferta válida por 15 días</div>
                </td>
            </tr>
        </table>

        <div class="info-box">
            <table class="info-table">
                <tr>
                    <td style="width: 50%;">
                        <div class="info-label">CLIENTE / EMPRESA SOLICITANTE</div>
                        <div class="info-value">${quote.client_name}</div>
                        ${quote.client_contact ? `<div style="font-size: 12px; color: #475569; margin-top: 2px;">Atn: <strong>${quote.client_contact}</strong></div>` : ''}
                    </td>
                    <td style="width: 50%;">
                        <div class="info-label">DETALLES DE LA PROPUESTA</div>
                        <div style="font-size: 12px; color: #475569;">
                            ${quote.client_email ? `✉️ ${quote.client_email}<br/>` : ''}
                            ${quote.client_phone ? `📞 ${quote.client_phone}<br/>` : ''}
                            Moneda: <strong>${quote.currency || 'CLP'}</strong> (Servicio Exento de IVA)
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <table class="table-itinerary">
            <thead>
                <tr>
                    <th style="width: 85px;">Fecha</th>
                    <th style="width: 60px;">Hora</th>
                    <th>Origen</th>
                    <th>Destino</th>
                    <th>Vehículo / Capacidad</th>
                    <th style="width: 100px; text-align: right;">Valor Tramo</th>
                </tr>
            </thead>
            <tbody>
                ${quote.items.map(item => `
                    <tr>
                        <td><strong>${item.date ? format(new Date(item.date), 'dd/MM/yyyy') : 'Por definir'}</strong></td>
                        <td>${item.time_str || '-'}</td>
                        <td><strong>${item.origin}</strong></td>
                        <td><strong>${item.destination}</strong></td>
                        <td>
                            <span class="badge-vehicle">${item.vehicle_type_name}</span>
                            <span class="badge-service" style="margin-left: 4px;">${item.service_type === 'full_day' ? 'Full Day' : (item.service_type === 'wait' ? 'Con Espera' : 'Traslado')}</span>
                            <div style="font-size: 10px; color: #64748b; margin-top: 2px;">👥 ${item.pax_count} pax</div>
                        </td>
                        <td style="text-align: right; font-weight: 700; color: #0f172a;">
                            ${currencySymbol} ${isUSD 
                                ? (item.sale_price || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : Math.round(item.sale_price || 0).toLocaleString('es-CL')
                            }
                        </td>
                    </tr>
                `).join('')}
            </tbody>
        </table>

        ${quote.notes_included ? `
            <div class="notes-card">
                <div class="notes-card-title">✨ SERVICIOS & REQUERIMIENTOS INCLUIDOS</div>
                <div class="notes-card-text">${quote.notes_included}</div>
            </div>
        ` : ''}

        <table class="totals-table">
            <tr>
                <td style="font-weight: 600; color: #64748b;">Subtotal Neto:</td>
                <td style="text-align: right; font-weight: 700;">${currencySymbol} ${formattedTotalCost}</td>
            </tr>
            <tr>
                <td style="font-weight: 600; color: #64748b;">IVA:</td>
                <td style="text-align: right; font-weight: 700; color: #16a34a;">$0 (Exento)</td>
            </tr>
            <tr class="total-row">
                <td>VALOR TOTAL:</td>
                <td style="text-align: right;">${currencySymbol} ${formattedTotalCost}</td>
            </tr>
        </table>

        <div class="footer-contact">
            <div class="footer-title">Transportes Emilia — Central de Coordinación</div>
            <div style="font-size: 11px; color: #64748b; margin-bottom: 6px;">
                Para confirmar esta cotización o coordinar detalles de la operación, por favor comunicarse con nuestras ejecutivas:
            </div>
            <div class="footer-details">
                📞 <span>+56 9 4269 1402</span> | ✉️ <span>info@transportesemilia.cl</span> | 🌐 <span>www.transportesemilia.cl</span>
            </div>
        </div>
    </body>
    </html>
    `;

    const printWin = window.open('', '_blank', 'width=900,height=800');
    printWin.document.write(htmlContent);
    printWin.document.close();
};
